import { Box, Typography } from "@mui/material";

export default function TableView({ title, text }: TableViewProps) {
    return (
        <Box mb={1}>
            <Typography variant="subtitle2" color="textSecondary">
                {title}
            </Typography>
            <Typography variant="subtitle1">
                {text}
            </Typography>
        </Box>
    );
}

interface TableViewProps {
    title: string;
    text: string;
}